import _api from '../_api';

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    name: null,
    version: 0,
    states: [],
    payment_methods: [],
    beforeRedirectFn: () => true,
    beforeRedirectPromise: null,
  },
  // -----------------------------------------------------------------
  getters: {
    name: (state,) => state.name,
    version: (state,) => state.version,
    states: (state,) => state.states,
    payment_methods: (state,) => state.payment_methods,
    getBeforeRedirect: (state,) => state.beforeRedirectFn,
  },
  // -----------------------------------------------------------------
  mutations: {
    setName: (state, name,) => (state.name = name),
    setVersion: (state, version,) => (state.version = version),
    setStates: (state, states,) => (state.states = states),
    setPaymentMethods: (state, methods,) => (state.payment_methods = methods),
    setBeforeRedirectFn: (state, fn,) => {
      if (fn) {
        state.beforeRedirectFn = fn;
      } else {
        state.beforeRedirectFn = () => new Promise((resolve,) => {
          state.beforeRedirectPromise = ({ resolve, });
        },);
      }
    },
  },
  // -----------------------------------------------------------------
  actions: {
    get: ({ commit, },) => {
      return _api.get().then(
        (appData,) => {
          commit('application/setName', appData.name, { root: true, },);
          commit('application/setVersion', appData.version, { root: true, },);

          return appData;
        },
        (error,) => {
          return _api.handleError(error,);
        },
      );
    },
    getStates: ({ commit, },) => {
      return _api.
        getStates().
        then((response,) => {
          commit('application/setStates', response, { root: true, },);

          return response;
        },).
        catch((e,) => {
          // throw e;
          return _api.handleError(e,);
        },);
    },
    getCities: (_, uf,) => {
      return _api.
        getCities(uf,).
        then((response,) => {
          return response;
        },).
        catch((e,) => {
          // throw e;
          return _api.handleError(e,);
        },);
    },
    fileUpload: async (_, data,) => {
      const policy = await _api.getFilePolicy({
        filename: data.header.name,
        contentType: data.header.type,
      },);

      const response = await _api.uploadFileWithPolicy(
        policy.data.endpoint_url,
        data,
        policy.data.params,
      );

      return {
        status: response.status,
        bucket: policy.data.bucket,
        key: policy.data.key,
        region: policy.data.region,
      };
    },
    fileDownload: async (_, params,) => {
      return _api.downloadFile(params,);
    },
    getPaymentMethods: async ({ commit, },) => {
      const response = await _api.getPaymentMethods();

      const validMethods = response.data.items.filter(
        (method,) => method.published,
      );

      commit('application/setPaymentMethods', validMethods, { root: true, },);

      return validMethods;
    },
    addDeferedRedirect: ({ commit, },) => {
      commit('setBeforeRedirectFn',);
    },
    releaseRedirect: ({ commit, state, }, value,) => {
      state.beforeRedirectPromise?.resolve(value,);
      commit('setBeforeRedirectFn', () => true,);
    },
    publicImageUpload: (_, imageData, ) => {
      return _api.uploadPublicImage(imageData,);
    },
    publicImageUpdate: (_, imageData,) => {
      return _api.updatePublicImage(imageData,);
    },
  },
};
